module.exports = __webpack_public_path__ + "media/images/kid/kid_avatar_04-7170a72a74fc87f5a54aa5287dbd42bb.png";